import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Realisations } from './components/Realisations';
import { Properties } from './components/Properties';
import { Services } from './components/Services';
import { ServicesPage } from './components/ServicesPage';
import { RealisationDetailPage } from './components/RealisationDetailPage';
import { ChaletGeminiPage } from './components/ChaletGeminiPage';
import { LodgesCombinsPage } from './components/LodgesCombinsPage';
import { TufetschPage } from './components/TufetschPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { SEO } from './components/SEO';
import { ScrollToTop } from './components/ScrollToTop';

const HomePage = () => {
  return (
    <>
      <SEO />
      <Header />
      <Hero />
      <Realisations />
      <Properties />
      <Services />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/realisation/eleven" element={<RealisationDetailPage />} />
            <Route path="/bien/chalet-gemini" element={<ChaletGeminiPage />} />
            <Route path="/bien/lodges-combins" element={<LodgesCombinsPage />} />
            <Route path="/bien/tufetsch" element={<TufetschPage />} />
            <Route path="/politique-confidentialite" element={<PrivacyPolicyPage />} />
            <Route path="/conditions-generales" element={<TermsOfServicePage />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;